var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{ref:"options_modal",attrs:{"title":_vm.title,"active":_vm.visibilityHandler},on:{"update:active":function($event){_vm.visibilityHandler=$event}}},[_c('div',{staticClass:"flex flex-wrap"},[_vm._l((_vm.options),function(option,idx){return [_c('div',{key:idx,staticClass:"option-wrapper",class:{
          'selected-option': _vm.value === option.value
        },on:{"click":function($event){return _vm.$emit('selected', option.value)}}},[_c('p',[_vm._v(_vm._s(option.label))])])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }